export default __webpack_public_path__ + "static/media/LogotipoHygraBlue.8dc59ee7.svg";